import { useParams, useNavigate } from 'react-router-dom';
import ProductionOrderDocument from '@/components/ProductionOrderDocument';

export default function ProductionOrderPrintView() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) return null;

  return (
    <div className="relative min-h-0 max-w-[740px] mx-auto">
      <div className="no-print mb-6 flex justify-end gap-3 px-8 pt-8">
        <button onClick={() => navigate(-1)} className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 text-sm">Cerrar</button>
        <button onClick={() => window.print()} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm">🖨️ Imprimir</button>
      </div>
      <ProductionOrderDocument orderId={id} />
    </div>
  );
}
